import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

export const routesAccount = [
  {
    path: "/app/account",
    component: () => import("vue-app/pages/PageAccount.vue"),
    meta: {
      routeName: window._trans["YOUR ACCOUNT"],
      noPadding: true,
      skipGlobalLoader: true,
    },
    children: [
      {
        path: "",
        name: "PageAccountProfile",
        component: () => import("vue-app/pages/PageAccountProfile/PageAccountProfile.vue"),
        meta: {
          routeName: window._trans["YOUR ACCOUNT"],
          skipGlobalLoader: true,
        },
      },
      {
        name: "PageAccountBilling",
        path: "billing",
        component: () => import("vue-app/pages/PageAccountBilling/PageAccountBilling.vue"),
        meta: {
          routeName: window._trans["YOUR ACCOUNT"],
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
        },
      },
      {
        name: "PageAccountShopSettings",
        path: "shop-settings",
        component: () => import("vue-app/pages/PageAccountShopSettings/PageAccountShopSettings.vue"),
        meta: {
          routeName: window._trans["YOUR ACCOUNT"],
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
        },
      },
      {
        name: "PageAccountEmails",
        path: "emails",
        component: () => import("vue-app/pages/PageAccountEmails/PageAccountEmails.vue"),
        meta: {
          routeName: window._trans["YOUR ACCOUNT"],
          noPadding: true,
          skipGlobalLoader: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
        },
      },
      {
        name: "PageAccountLimits",
        path: "limits",
        component: () => import("vue-app/pages/PageAccountLimits/PageAccountLimits.vue"),
        meta: {
          routeName: window._trans["YOUR ACCOUNT"],
          noPadding: true,
          requiredRoles: [AGENT_TRACKER_ROLE.ROLE_SETTINGS],
          skipGlobalLoader: true,
        },
      },
    ],
  },
];
